var Education = "Éducation";
var Enterprise = "Entreprise";
var CompanyType = {
	"Company type": "Type d'entreprise",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "Gouvernement – fédéral",
	"Government - State & local": "Gouvernement – d'État et local",
	"Non-profit": "Organisme à but non lucratif",
	"Self employed": "Travailleur indépendant",
	"Small-medium business": "Petite et moyenne entreprise",
	"Start-up": "Startup",
	"Not applicable": "Ne s'applique pas"
};

export { Education, Enterprise, CompanyType as default };
